module.exports = __webpack_public_path__ + "../resources/images/scene-search-foundation-2153a934f6f5cbb37d6ac604ac4b5326.png";